import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'bt-photographer',
  templateUrl: './photographer.component.html',
  styleUrls: ['./photographer.component.scss']
})

export class PhotographerComponent {
}
